import * as Switch from './Switch';
import * as Status from './Status';
import * as Documents from './Documents';
import * as Pictogram from './Pictogram';
import * as Health from './Health';
import * as Healthdata from './Healthdata';
import * as Navigation from './Navigation';
import * as People from './People';
import * as Tool from './Tool';
import * as Training from './Training';

const icons = {
  ...Switch,
  ...Status,
  ...Documents,
  ...Pictogram,
  ...Health,
  ...Healthdata,
  ...Navigation,
  ...People,
  ...Tool,
  ...Training,
};

export default icons;
